import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreateSupplierMutation, CreateSupplierMutationVariables, useCreateSupplierMutation } from '../../../../generated/graphql';
import SupplierForm from './SupplierForm';
import { CreateSupplierFormValues } from './types';

interface CreateSupplierForm {
    isDialogView?: boolean;
    onCompleted?(mutationResult: CreateSupplierMutation): void;
}

const CreateSupplierForm = ({ isDialogView, onCompleted }: CreateSupplierForm) => {
    const { t } = useTranslation();
    const [createSupplier] = useCreateSupplierMutation({ onCompleted });
    const onSubmit = async ({
        legalName,
        district,
        headquarters,
        postalCode,
        tin,
        companyIdentificationNumber,
    }: CreateSupplierFormValues) => {
        const variables: CreateSupplierMutationVariables = {
            data: {
                legalName,
                district,
                headquarters,
                postalCode,
                tin,
                companyIdentificationNumber,
            }
        };
        try {
            await createSupplier({ variables });
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <SupplierForm isDialogView={isDialogView} submitText={t('Create supplier')} onSubmit={onSubmit} />
    );
};

export default CreateSupplierForm;
